<template>
    <sys-teacher-hub-modal
        :show="show"
        @update:show="$emit('update:show', $event)"
        :title="title"
        :icon="icon"
        max-width="980"
    >
        <v-card-text class="pa-2">
            <sys-teacher-discipline
                :teacher="teacher"
                :token="token"
                :text="teacher?.realInstitution?.text_interest || null"
                @onComplete="handleOnComplete"
            />
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
export default {
    name: 'SysTeacherDisciplinesInterestHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            default: () => ({})
        },
        token: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: 'mdi-heart-outline'
        },
        title: {
            type: String,
            default: 'Disciplinas de Interesse'
        }
    },
    methods: {
        handleOnComplete(event) {
            if (!event || !event.text) return
            this.$emit('onComplete', event)
        }
    }
}
</script>
